import type { Validator } from 'api/types';
import ErrorMessage from 'components/NewLayout/ErrorMessage';
import type { ChangeEvent } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

type SyntheticChange = { target: { name: string; value: string } };
type HandleChange = (
  e: ChangeEvent<HTMLInputElement | HTMLSelectElement> | SyntheticChange
) => void;

export default function PhoneNumberInput({
  value,
  handleChange,
  disabled,
  isRequired,
  name,
  validator,
  validationString
}: {
  value?: string;
  handleChange: HandleChange;
  disabled?: boolean;
  label?: string;
  isRequired?: boolean;
  name: string;
  validator?: Validator;
  validationString?: string;
}) {
  const isError = validator?.current?.message(name, value, validationString || 'required');

  return (
    <div style={{ position: 'relative' }}>
      <style>{`
        .react-tel-input .country-list .country {
          display: flex !important;
          align-items: center !important;
          padding: 8px 12px !important;
          height: auto !important;
          line-height: 1 !important;
        }

        .react-tel-input .country-list .country .flag {
          margin-right: 12px !important;
          flex-shrink: 0 !important;
          vertical-align: middle !important;
          display: inline-block !important;
        }

        .react-tel-input .country-list .country .country-name {
          flex: 1 !important;
          margin: 0 !important;
          padding: 0 !important;
          vertical-align: middle !important;
          display: inline-block !important;
          line-height: 1.2 !important;
          margin-left: 24px !important;
        }

        .react-tel-input .country-list .country .dial-code {
          margin-left: auto !important;
          flex-shrink: 0 !important;
          vertical-align: middle !important;
          display: inline-block !important;
        }
      `}</style>

      <PhoneInput
        country="us"
        onlyCountries={['us', 'gb', 'de']}
        onChange={(phone) => handleChange({ target: { name, value: phone } })}
        disabled={disabled}
        value={value}
        inputStyle={{ width: '100%' }}
        buttonStyle={{ border: 'none', backgroundColor: 'transparent' }}
        dropdownStyle={{
          width: '100%',
          minWidth: '250px',
          maxHeight: '200px'
        }}
        specialLabel="Phone Number"
        containerClass={`phone-input ${isRequired && isError ? 'red-border' : ''}`}
        countryCodeEditable={false}
      />

      {isRequired && (
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '5px',
            color: 'red',
            zIndex: 1
          }}>
          *
        </span>
      )}

      {isRequired && isError ? (
        <ErrorMessage
          validator={validator}
          value={value}
          label={name}
          validationString={validationString || ''}
        />
      ) : (
        <p />
      )}
    </div>
  );
}
